//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import {
  required, email,
} from 'vuelidate/lib/validators';

import * as reCaptcha from '@motionelements/helper/reCaptchaEnterprise.js';
import { subscribeFreeEdm } from '@/api/edm.js';

export default {
  name: 'free-edm-form',
  components: {
    ButtonLadda: () => import('@motionelements/core/src/components/ui/BaseButtonLadda.vue'),
    BaseInputText: () => import('@motionelements/core/src/components/ui/form/BaseInputText.vue'),
  },
  data() {
    return {
      isValid: null,
      isShowEmail: true,
      message: '',
      isLoading: false,
      form: {
        email: '',
      },
    };
  },
  validations: {
    form: {
      email: {
        email,
        required,
      },
    },
  },
  computed: {
    ...mapState({
      component: state => state.modal.component,
      props: state => state.modal.props,
    }),
  },
  methods: {
    async submitFreeSubscribe() {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;

      if (!this.$v.form.$invalid) {
        this.isLoading = true;
        const recaptchaToken = await reCaptcha.getToken('edm_subscribe');

        // send recaptcha by headers
        const headers = { 'x-g-recaptcha-response': recaptchaToken };

        return subscribeFreeEdm({
          email: this.form.email,
        }, { headers }).then((response) => {
          const message = response.data.message;
          this.isShowEmail = false;
          this.isLoading = false;
          this.message = message;
        }).catch((error) => {
          console.error(error);
          this.isShowEmail = false;
          this.isLoading = false;
          this.message = error.message;
        });
      }
    },
  },
};
